import { ADD_FILTER, REMOVE_FILTER, RESET_FILTERS, ADD_FILTERS } from "../../../actions";

export default function (filters, action) {
  switch (action.type) {
    case ADD_FILTER:
      return [...filters, action.filter];
    case ADD_FILTERS:
      return [...filters, ...action.filters];
    case REMOVE_FILTER:
      return filters.filter(f => f.capability !== action.filter.capability || f.value !== action.filter.value);
    case RESET_FILTERS:
      return [];
    default:
      return filters;
  }
}






// WEBPACK FOOTER //
// ./src/redux/reducers/elements/filters/index.js